<template>

  <div>
    <!-- <div class="c-model-baner-text">
    <h2>Zadzwoń <a href='tel:324328480' class='red_text'>32 432 84 80</a><br>lub <a class='red_text show_form' v-on:click="askforofferfix()">wypełnij formularz</a></h2>
  </div> -->
  <div class="c-sectionText" id="topofpage">
    <!-- <div class="c-sectionText-header">
      <h2>Sprawdź modele Audi<br />
        dostępne w naszym salonie!</h2>
      </div> -->
      <div class="c-sectionText-paragraph">
        <!-- <p>
        Nie czekaj, ciesz się już dziś swoim nowym Audi.
      </p>
      <br />
      <p>
      Zobacz wyjątkowe modele, które wyróżnia sportowy design, niezwykły komfort i wsparcie inteligentnych technologii.
    </p>
    <br /> -->
    <p class="c-sectionText-text">
      <strong>
        Audi Q5
      </strong> łączy dynamikę z najwyższą funkcjonalnością na co dzień. Wyraźny design podkreśla sportowy charakter tego SUV-a, a napęd na cztery koła quattro zapewnia emocje na każdej drodze.  <br><br>
      Nie wahaj się i zdecyduj się na model Q5, który zapewni komfort Twoim podróżom na najwyższym poziomie.
    </p>
  </div>

  </div>
  <div class="c-gallery-container">
    <div class="c-gallery">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery1.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery2.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery3.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery4.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery5.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery6.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery7.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery8.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery9.jpg" alt="Audi Q5">
        </swiper-slide>
        <swiper-slide>
            <img src="@/assets/images/gallery/gallery10.jpg" alt="Audi Q5">
        </swiper-slide>



        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
      <div class="swiper-button-prev" @click="prevSlide"></div>
      <div class="swiper-button-next" @click="nextSlide"></div>
    </div>
  </div>
  <div class="c-sectionText" id="topofpage">

      <div class="c-sectionText-paragraph">
    <h3>
      Wybierz wersję samochodu dopasowaną do swoich potrzeb. <br>
      Samochody gotowe do odbioru czekają w salonie Audi Kraków Zakopiańska! Zapraszamy!
    </h3>

    <p class="c-sectionText-text">
      <br><br> Zadzwoń &nbsp;<br class="mobile-br"><a class=" link-btn" href="tel:+48 123631980 ">12 363 19 80 </a> <br class="mobile-br"> &nbsp; &nbsp;lub &nbsp;&nbsp;<br class="mobile-br"><a class="link-btn form-open " v-on:click="askforoffer();">wyślij&nbsp;formularz!</a>
    </p>


    <!-- <a class="c-sectionText-button" href="http://audikrakow.pl/dobra-energia/" target="_blank">
    Sprawdź modele z dodatkową premią ekologiczną
  </a> -->
</div>

</div>

<!-- <div class="box_searcher-div">
  <div>
    <h3>Wybierz ofertę</h3>

    <select class="box_searcher" v-model="params.model_id" @change="cleanup_model(params.model_id),getOffers()">
      <option value="" disabled selected>Model</option>
      <option value="">Wszystkie</option>
      <option v-for="model in models" v-bind:key="model.id" v-bind:value="model.id" >{{ model.name }}</option>
    </select>

    <select class="box_searcher" v-model="params.price_to" @change="cleanup_params(params.price_to),getOffers()">
      <option value="" disabled selected>Cena</option>
      <option value="">Wszystkie</option>
      <option value="120000">do 120 000 zł</option>
      <option value="150000">do 150 000 zł</option>
      <option value="200000">do 200 000 zł</option>
      <option value="250000">do 250 000 zł</option>
      <option value="300000">do 300 000 zł</option>
      <option value="350000">do 350 000 zł</option>
      <option value="3500000">powyżej 350 000 zł</option>
    </select>

    <select class="box_searcher" v-model="params.type_id" @change="cleanup_type_offer(params.type_id),getOffers()">
      <option value="" disabled selected>Typ oferty</option>
      <option value="">Wszystkie</option>
      <option value="3">Nowe</option>
      <option value="2">Używane</option>
      <option value="4">Demo</option>
    </select>
  </div>
</div> -->
<div class="offer">

  <div class=" ">
      <div class="">
        <div class="model__list">
          <div class="model__content"  v-for="(offer,key) in offers">
            <div class="model__number">
              <!-- <div class="rabat" v-if="offer.price_list != 0 && offer.price != offer.price_list">
                Korzyść<br /><span>{{ priceFormat.to(calc(offer.price_list,offer.price)) }} zł</span>
              </div>
              <div class="rabat" v-if="offer.price === offer.price_list" v-scroll-to="'#form'" style="cursor:pointer">
                Sprawdź <br /><span>korzyści</span>
              </div> -->
              <div class="c-model-list-image">
                <img :src="offer.photo_md" :alt="offer.title" class="img-responsive">

                <!-- <img class="c-model-list-image-nakladka" src="https://images.piamarket.pl/volkswagen/nakladka_piamarket_06_02.png" alt="Zlap okazje"> -->
              </div>
            </div>
            <div class="model__content-header">
              <h3>{{ offer.brand_name }} {{ offer.model_name }} </h3>

              <div class="model__content-benefit" v-if="offer.price_list != 0 && offer.price != offer.price_list">z korzyścią <b>{{  priceFormat.to(calc(offer.price_list,offer.price)) }} zł</b></div>
              <!-- <div class="model__content-offernr" v-if="offer.dealer_name != ''">{{ offer.dealer_name.replace(/Volkswagen|Volkswagen Osobowe|Osobowe/gi, "") }}</div> -->
              <div class="model__content-offernr" v-if="offer.id != ''">Nr oferty: <b>{{ offer.id }}</b></div>
            </div>
            <div class="border-right">

            </div>
            <div class="model__content-info">
              <p v-if="offer.version != ''">
                {{ offer.version }}
              </p>
              <br>
              <div class="flex mg-bottom">
                <!-- <div class="elem" v-if="offer.version != ''">
                  {{ offer.version }}
                </div> -->
                <div class="elem" v-if="offer.fuel != ''">
                  {{ offer.fuel }}
                </div>
                <div class="elem" v-if="offer.power != ''">
                  {{ offer.power }} KM
                </div>
                <div class="elem" v-if="offer.transmission != ''">
                  {{ offer.transmission }}
                </div>
              </div>
              <div v-if="offer.color != ''">
                <!-- <div class="color-pointer" v-bind:style="{'background-color':'#'+offer.color_code}"></div>  -->
                Kolor: <b>{{ offer.color }}</b>
              </div>
            </div>
            <div class="border-right">

            </div>
            <div class="model__content-price">
              <div class="mg-right">
                <div class="price-flex" v-if="offer.price_list != '' && offer.price_list != offer.price">
                  <div class="text-height">
                    <span class="price-name">Cena <br>katalogowa:</span>
                  </div>
                  <div class="oldprice">
                    {{ priceFormat.to((offer.price_list)) }} zł
                  </div>
                </div>
                <div class="price-flex" v-if="offer.price_month != ''">
                  <div class="text-height">
                    <span class="price-name">Rata od:</span>
                  </div>
                  <div class="">
                    {{ priceFormat.to((offer.price_month)) }} zł | mies
                  </div>
                </div>
                <div class="price-flex" v-if="offer.price != ''">
                  <div class="text-height">
                    <span class="price-name">Cena <br> promocyjna:</span>
                  </div>
                  <div class="price">
                    {{ priceFormat.to((offer.price)) }} zł
                  </div>
                </div>

              </div>
              <!-- <div class="">
                <h2 v-if="offer.price_month != ''">
                  Rata od: <br>
                  <span class="fix"><strong>{{ priceFormat.to((offer.price_month)) }}</strong>&nbsp;&nbsp;|&nbsp;&nbsp;mies.</span>
                </h2>
              </div> -->
            </div>
            <div class="border-right">

            </div>
            <div class="bttn-wrap">
              <!-- v-scroll-to="'#form'"  -->
              <div class="model__content-bttn" v-on:click="askforoffer(offer.id, offer.type_id)" onclick="gtag('event','klikniecie w zapytaj o rabat')">
                Zapytaj o ofertę
              </div>
              <a :href="'https://www.piamarket.pl/szczegoly-oferty/'+offer.url+'/'+offer.id+'/?campaign_id=955'" target="_blank" onclick="gtag('event','klikniecie w wiecej szczegolow')">
                <div class="details-bttn" >
                  więcej szczegółów
                </div>
              </a>


            </div>
          </div>
        </div>

      </div>
    </div>

</div>

<div class="c-pagination">
  <button class="c-pagination-button" v-if="params.page-2 > 0" v-on:click="loadMore(1)"> 1 </button>
  <button class="c-pagination-button" v-if="params.page-3 > 0" > ... </button>
  <div class="" v-for="page in pages" :key="page">
    <button class="c-pagination-button"  v-if="page > params.page-2 && page < params.page+2"  v-on:click="loadMore(page)" v-bind:class="{ 'active' : params.page == page}">{{page}}</button>
  </div>

  <button class="c-pagination-button" v-if="pages > params.page+2" > ... </button>
  <button class="c-pagination-button" v-if="pages > params.page+1" v-on:click="loadMore(pages)"> {{ pages }} </button>

</div>
<!-- <div class="c-button-cars" @click="loadMore()" v-if="loader">
  POKAŻ WIĘCEJ OFERT
</div> -->

<div class="c-model-baner-text" v-if="offers == 0">
  <br />
  <br />
  <br />
  <!-- <h2>Brak ofert</h2> -->
  <h2 v-html="offerMsg">
  </h2>
  <div class="text-center" v-if="msgBtn">
    <div class="link-btn" @click="askforoffer()">
      Wyślij formularz!
    </div>
  </div>

</div>
<p class="disclaimer fix">Prezentowane informacje są wyłącznie informacją handlową i nie stanowi oferty w myślart. 66 § 1 i art. 556 indeks 1 Kodeksu Cywilnego. Porsche Inter Auto Polska zastrzega sobie prawo do doprecyzowania oraz korekt omyłek.</p>
</div>
</template>

<script type="text/javascript">
// import this.$http from 'this.$http'
import wnumb from 'wnumb'
import 'url-search-params-polyfill'

export default {
  name: 'offers',
  data: function data () {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        slidesPerView: 4,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 3
          },
          768: {
            slidesPerView: 4
          }
        }
        // Some Swiper option/callback...
      },
      apiUrl: 'https://webapi.porscheinterauto.com.pl/cars',
      // params: {
      //   pf:0,
      //   pt:"",
      //   ty:2,
      //   yf:2019,
      //   yt:2020,
      // },
      params: {
        brand_id: 9,
        model_id: 87,
        limit: 5,
        offset: 0,
        page: 1,
        order: 3,
        order2: 1,
        type_id: 1,
        production_year_from: 2020,
        production_year_to: 2021,
        price_from: 0,
        price_to: '',
        dealer_id: 33,
        ids: []
      },
      or_vins: [

      ],
      render_models: '',
      offers: [],
      models: {},
      sorted_models: {},
      loading: true,
      loader: true,
      pages: 0,
      offerMsg: '',
      msgBtn: false,
      priceFormat: wnumb({
        mark: '',
        thousand: ' ',
        prefix: '',
        suffix: ' '
      })
    }
  },
  computed: {
    swiper() {
       return this.$refs.mySwiper.$swiper
     }
  },
  mounted(){
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
  methods: {
    prevSlide: function prevSlide(){
      this.$refs.mySwiper.$swiper.slidePrev()
    },
    nextSlide: function nextSlide(){
      this.$refs.mySwiper.$swiper.slideNext()

    },
    setModel: function setModel (val) {
      this.params.limit = 100
      this.params.model_id = val
    },
    getModels: function getModels () {
      var that = this
      this.$http
        .get('https://webapi.porscheinterauto.com.pl/car-models?brand_id=9', {

        })
        .then(function (response) {
          that.models = response.data.models
        })
        .catch(function () {
          window.alert('Sprawdź połączenie z internetem!')
        })
    },
    async getids () {
      const { data } = await this.$http
        .get('https://webapi.porscheinterauto.com.pl/car-ids', {
          params: {
            ...this.params,
            or_vins: this.or_vins
          }
        })
      this.params.ids = data.ids
    },
    askformore: function askformore (value) {
      console.log(value)
      gtag('event', 'Kliknięcie sprawdź szczegóły modelu' + value)
    },
    cleanup_model: function cleanup_model (value) {
      // this.$router.push({name: 'car=', query: { page: value } });
      gtag('event', 'Filtrowanie modelu: ' + value)
      window.history.pushState(null, null, '?car=' + value)
      this.params.page = 1
      this.offers = []
    },
    cleanup_params: function cleanup_params (value) {
      if (value === '3500000') {
        this.params.price_to = value
        this.params.price_from = 350000
      } else {
        this.params.price_to = value
        this.params.price_from = 0
      }
      gtag('event', 'Wybranie ceny od ' + value)
      this.params.page = 1
      this.offers = []
    },
    cleanup_type_offer: function cleanup_type_offer (value) {
      if (value === '') {
        this.params.type_id = ''
      } else {
        this.params.type_id = value
      }
      this.params.page = 1
      this.offers = []
    },
    askforoffer: function askforoffer (value, value_type) {
      gtag('event', 'Kliknięcie zapytaj o ofertę nr: ' + value)
      if (value_type == 1) {
        this.$store.dispatch('openForm', { data: true })
        if (value != undefined) {
          this.$store.dispatch('changedesc', { data: 'Jestem zainteresowany ofertą nr. ' + value + ' - nowy' })
        }
      } else if (value_type == 2) {
        this.$store.dispatch('openForm', { data: true })
        if (value != undefined) {
          this.$store.dispatch('changedesc', { data: 'Jestem zainteresowany ofertą nr. ' + value + ' - używany' })
        }
      } else {
        this.$store.dispatch('openForm', { data: true })
        if (value != undefined) {
          this.$store.dispatch('changedesc', { data: 'Jestem zainteresowany ofertą nr. ' + value })
        }
      }
      // document.getElementById('description').value = 'Jestem zainteresowany ofertą nr. ';
    },
    askforofferfix: function askforofferfix (value) {
      gtag('event', 'Kliknięcie zapytaj o ofertę nr: ' + value)
      this.$store.dispatch('openForm', { data: true })
      this.$store.dispatch('changedesc', { data: '' })
    },
    calc: function calc (value1, value2) {
      return value1 - value2
    },
    getOffers: function getOffers () {
      var t = this
      t.loading = true

      this.$http
        .get(t.apiUrl, {
          params: t.params
        })
        .then(function (response) {
          if (t.offers.length != 0) {
            t.offers = t.offers.concat(response.data.cars)
          } else {
            t.offers = response.data.cars
          }
          t.pages = Math.ceil(response.data.count / t.params.limit)

          if (t.offers.length === 0) {
            setTimeout(function () {
              t.offerMsg = 'Wybrany model jest niedostępny.<br>Skonfiguruj z nami swoje wymarzone Audi'
              t.msgBtn = true
            }, 1000)
          } else {
            t.msgBtn = false
            t.offerMsg = 'Szukamy dla Ciebie ofert...'
          }

          if (response.data.cars.length < 8) {
            t.loader = false
          } else {
            t.loader = true
          }
        })
        .catch(function () {
          window.alert(
            'Błąd pobierania ofert. Sprawdź swoje połączenie z internetem'
          )
        })

      t.loading = false
    },
    loadMore: function loadMore (page) {
      var that = this
      gtag('event', 'Kliknięcie pokaż więcej ofert')
      // this.load = true;
      // this.params.page = this.params.page + 1;
      this.params.page = page
      var offerlist = document.getElementById('topofpage')
      var topList = offerlist.offsetTop
      this.$http
        .get('https://webapi.porscheinterauto.com.pl/cars', {
          params: this.params
        }).then(function (response) {
          if (response.data.cars.length > 0) {
            that.offers = []
            that.offers = that.offers.concat(response.data.cars)
            window.scrollTo(0, topList)
          }

          if (response.data.cars.length < 8) {
            that.loader = false
          } else {
            that.loader = true
          }

          setTimeout(function () {
          // that.load = false;
          }, 300)
        }, function () {
          window.alert('Sprawdź Połączenie z internetem!')
        })
    }
  },
  watch: {
    'params.ids': {
      handler: function handler () {
        this.getOffers()
      },
      deep: true
    },
    offers: {
      handler: function handler () {
        // console.log("test");
      },
      deep: true
    }
  },
  created: function created () {
    var that = this
    that.getModels()

    // var queryString = window.location.search

    // var urlParams = new URLSearchParams(queryString)
    //
    // urlParams.get('car')
    //
    // if (urlParams.get('car') != undefined) {
    //   that.params.model_id = urlParams.get('car').toLowerCase()
    // } else {
    //   that.params.model_id = ''
    // }

    // this.getids()
    this.getOffers()
    // .then(this.getOffers());
    console.log('RDY 2 GO !')
  }
}
</script>
